import { InferGetStaticPropsType } from 'next';
import Image from 'next/image';

import { hnaviShortTitle, hnaviTitle } from '@constants';
import { Layout2, SideContents, BackHomeButton } from '@components';
import NotFound from '@images/404.png';
import { isrRevalidateSec } from '@constants';
import { getHnaviOptions, getAllCategoryNamesAndSlugs2 } from '@api';
import { getHnaviContentCategoriesFromCategories } from '@helpers';

const Custom404: React.FC<InferGetStaticPropsType<typeof getStaticProps>> = ({
  hnaviOptions,
  hnaviContentCategories,
}) => {
  return (
    <Layout2
      useHnaviHeader
      hnaviContentCategories={hnaviContentCategories}
      breadcrumbs={[
        { text: hnaviTitle, shortText: hnaviShortTitle, url: '/' },
        { text: 'ページが見つかりませんでした' },
      ]}
      sideBar={<SideContents fixedBanner={hnaviOptions.banners.buyerFixed} />}
    >
      <Image
        src={NotFound.src}
        width={NotFound.width}
        height={NotFound.height}
        className='mx-auto max-w-full'
        alt='404'
      />
      <BackHomeButton />
    </Layout2>
  );
};

export const getStaticProps = async () => {
  console.info(`getStaticProps: the 404 page`);
  return {
    props: {
      hnaviOptions: await getHnaviOptions(),
      hnaviContentCategories: getHnaviContentCategoriesFromCategories(
        await getAllCategoryNamesAndSlugs2()
      ),
    },
    revalidate: isrRevalidateSec,
  };
};

export default Custom404;
